import { format, isValid } from "date-fns";
import yaml from "js-yaml";
import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import { cn } from "@/lib/utils";
import { AgentMessage } from "@/models/agent/message";

interface Props {
  message: AgentMessage;
  className?: string;
}

/**
 * ToolResponseMessage - ツール実行結果用
 * 通常のメッセージリストには表示しない（ツールパネル内で使用）
 */
const ToolResponseMessage: React.FC<Props> = () => {
  // tool_responseは通常のメッセージリストには表示しない
  // ツールパネル内でfunction_responseとして表示される
  return null;
};

/**
 * ツールパネル内でのシステムメッセージ表示用
 */
export const ToolResponseMessageForToolPanel: React.FC<Props> = ({
  message,
  className,
}) => {
  let contentJson: Record<string, unknown> = {};

  if (typeof message.content === "object" && message.content) {
    contentJson = message.content;
  } else if (typeof message.content === "string") {
    try {
      contentJson = JSON.parse(message.content);
    } catch {
      contentJson = { message: message.content };
    }
  }

  return (
    <div className={className}>
      <div className={cn("bg-gray-50 rounded-lg p-1 mb-3", className)}>
        <SyntaxHighlighter
          language="yaml"
          style={oneLight}
          lineProps={{
            style: {
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
              overflowWrap: "anywhere",
            },
          }}
          customStyle={{
            margin: 0,
            padding: "12px",
            fontSize: "13px",
            backgroundColor: "#fafafa",
            borderRadius: "6px",
            fontFamily: "Monaco, 'Courier New', monospace",
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
          }}
          showLineNumbers={false}
          wrapLongLines
        >
          {yaml.dump(contentJson, {
            indent: 2,
            lineWidth: -1,
            noRefs: true,
            sortKeys: false,
          })}
        </SyntaxHighlighter>
      </div>

      {/* タイムスタンプ */}
      <div className="text-xs text-gray-400 mt-2 text-right">
        {isValid(message.createdAt) && format(message.createdAt, "yyyy/M/d H:mm")}
      </div>
    </div>
  );
};

export default ToolResponseMessage;
